import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Articles from '../components/Articles';
import { PageMetadata } from '../components/PageMetadata';

export default function ArticlesPage() {
  return <div className="page-content">
    <PageMetadata title="Selected Articles & Technical Writing | Elena Nurullina" description="Published technical articles, tutorials, and engineering insights by Elena Nurullina." />
    <div className="container"><Link to="/" className="back-link"><ArrowLeft size={18} aria-hidden="true" />Back to Home</Link></div>
    <Articles />
  </div>;
}
